module.exports = __webpack_public_path__ + "static/img/love2.1b3a4fb2.png";